export enum StorageValues {
  HiddenMuteModalEvents = 'hiddenMuteModalEvents',
  DismissMessages = 'dismissMessages',
}
